import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CurrentCartStoreService, DeliveryInformationStoreService } from '@common/services';
import { RoutesResRoutes } from '@conf/routes.config';
import { SupportComponent } from '@lib/components/support-class';
import { CommonLibService } from '@lib/services';
import { FormControl } from '@angular/forms';
import { deepCopy } from '../../../../common/helper/deep-copy';
import { AnaBizContextModel, AnaBizLoginStatusType, AswContextType } from '@lib/interfaces';
import { CheckboxComponent } from '@lib/components';

@Component({
  selector: 'asw-biz-payment-test',
  templateUrl: './biz-payment-test.component.html',
  styleUrls: ['../../test-ssn.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BizPaymentTestComponent extends SupportComponent implements OnInit {
  public text = '';
  public selectContractType = new FormControl();

  reload(): void {}
  init(): void {}
  destroy(): void {}

  constructor(
    private _common: CommonLibService,
    private _router: Router,
    private _currentCartService: CurrentCartStoreService,
    private _deliveryInfoService: DeliveryInformationStoreService
  ) {
    super(_common);
  }

  contractTypeChange() {
    let bizContext = deepCopy(this._common.anaBizContextStoreService.anaBizContextData);
    if (bizContext.authInfo) {
      bizContext.authInfo.contractType = this.selectContractType.value;
      this._common.anaBizContextStoreService.setAnaBizContext(bizContext);
    }
  }

  issueFlagUpdate(checkbox: CheckboxComponent) {
    let bizContext = deepCopy(this._common.anaBizContextStoreService.anaBizContextData);
    if (bizContext.authInfo?.companyInfoC) {
      bizContext.authInfo.companyInfoC.issueFlag = checkbox.checked ? '1' : '0';
      this._common.anaBizContextStoreService.setAnaBizContext(bizContext);
    }
  }

  organizationSelectRequired() {
    this._common.aswContextStoreService.updateAswContext({
      [AswContextType.ANA_BIZ_LOGIN_STATUS]: AnaBizLoginStatusType.ORGANIZATION_SELECT_REQUIRED,
    });

    const data: Required<AnaBizContextModel> = {
      authInfo: {
        companyCode: 'FCL12345',
        companyAccountCode: 'SCL12345',
        contractType: '01',
        companyInfoA: {
          cancellationDate: '2025-12-28',
          companyName: 'テスト企業1',
          companyNameEn: 'TEST COMPANY1',
          issueFlag: '0',
          pauseFlag: '0',
          onePaxFlag: '0',
          eCffList: ['infoAeCff1', 'infoAeCff2', 'infoAeCff3', 'infoAeCff4'],
          fCffList: ['infoAfCff1', 'infoAfCff2', 'infoAfCff3', 'infoAfCff4'],
        },
        companyInfoC: {
          cancellationDate: '2033-01-01',
          contractSecName: 'テスト契約部署1',
          contractSecNameEn: 'TEST CONTRACT SEC1',
          issueFlag: '0',
          pauseFlag: '1',
          onePaxFlag: '1',
          eCffList: [],
          fCffList: [],
        },
        companyManagementCodeInfo: {
          texts: [
            {
              no: '1',
              activateFlag: '1',
              code: 'ABC',
            },
            {
              no: '2',
              activateFlag: '1',
              code: 'DEF',
            },
            {
              no: '3',
              activateFlag: '1',
              code: 'GHI',
            },
            {
              no: '4',
              activateFlag: '1',
              code: 'JKL',
            },
          ],
          comboNames: ['TEST1', 'TEST2', 'TEST3', 'TEST4'],
        },
        roles: ['TRAVELER', 'APPROVER', 'DEPARTMENT_ADMINISTRATOR', 'COMPANY_ADMINISTRATOR'],
      },
      seamlessParameter: {
        amcMemberNumber: '9904700095',
        companyManagementCode1: '',
        companyManagementCode2: '',
        companyManagementCode3: '',
        companyManagementCode4: '',
        departureDate1: '2024-08-28',
        departureDate2: '2024-09-11',
        sendDataFlag: '0',
        sendDataUrl: '',
        sendDataType: '1',
      },
    };
    this._common.anaBizContextStoreService.updateAnaBizContext(data);
  }

  initPrevScreenStore() {
    this._deliveryInfoService.updateDeliveryInformation({
      passToPayment: {
        errInfo: [],
        orderId: 'abcde',
        credential: {
          firstName: 'tarou',
          lastName: 'sorayama',
        },
      },
    });
  }

  anaBizTest1() {
    this._currentCartService.updateCurrentCart({ data: { cartId: '111222' } });
    this._router.navigateByUrl(RoutesResRoutes.ANABIZ_PAYMENT_INPUT);
  }
}
